export const DriverDetailsQueryTab = {
    HeaderTable: ["Parameter", "Value", "Required", "Example"],
    HeaderBodyTable: [
      {
        Parameter: "email",
        Value: "String",
        Required: "true",
        Example: "abc@email.com (Enter the given Login Email)",
      },
      {
        Parameter: "bookingId",
        Value: "String",
        Required: "true",
        Example: "D0824-2262",
      },
    ],
  };
